// extracted by mini-css-extract-plugin
export var honor_title_container = "index-module--honor_title_container--4333d";
export var statistics_container = "index-module--statistics_container--e424c";
export var statistics_tips = "index-module--statistics_tips--483ef";